import lottie, { AnimationItem, AnimationSegment } from 'lottie-web';
import { Injectable, NgZone } from '@angular/core';
import { IAnimationData } from './animation.data';

@Injectable({
  providedIn: 'root',
})
export class AnimationService {
  constructor(private ngZone: NgZone) {}

  loadAnimation(data: IAnimationData): AnimationItem {
    return this.ngZone.runOutsideAngular(() => lottie.loadAnimation(data));
  }

  loadMultipleAnimations(dataArray: IAnimationData[]): AnimationItem[] {
    return this.ngZone.runOutsideAngular(() =>
      dataArray.map((data: IAnimationData) => lottie.loadAnimation(data))
    );
  }

  playAnimation(
    animationItem: AnimationItem,
    segments: AnimationSegment | AnimationSegment[],
    forceFlag?: boolean
  ) {
    animationItem.playSegments(segments, forceFlag);
  }
}
